<template>
    <div class="ui bulleted list">
        <div class="list-item" v-for="(item) in summaryItems">
            <span v-html="item"></span>
        </div>
    </div>
</template>

<script>
    import capitalize from '@/common/helpers/capitalize';
    import BaseActionSummary from '../base-action-summary';
    import RequestKYCSummaryFields, {resolveLabel} from './request-kyc-summary-fields';

    export default {
        name: 'request-kyc-summary',
        extends: BaseActionSummary,
        computed: {
            summaryItems() {
                return RequestKYCSummaryFields.map(({
                    name, summary, labels, policies,
                }) => (typeof labels === 'function'
                    ? `${capitalize(summary)} ${labels(this.action[name], this.action)}`
                    : `${capitalize(summary)} ${resolveLabel(labels, policies, this.action[name])}`));
            },
        },
        methods: {},
    };
</script>
